export enum AmarilloCities {
  Adrian = 'adrian',
  Alanreed = 'alanreed',
  Allison = 'allison',
  Amarillo = 'amarillo',
  Amherst = 'amherst',
  AngelFire = 'angelfire',
  Angleton = 'angleton',
  AransasPass = 'aransasPass',
  Arthur = 'arthur',
  Athens = 'athens',
  Austin = 'austin',
  Azle = 'azle',
  Balko = 'balko',
  Bandera = 'bandera',
  Bangs = 'bangs',
  Bartlett = 'bartlett',
  Bastrop = 'bastrop',
  Batson = 'batson',
  Beaumont = 'beaumont',
  Beaver = 'beaver',
  Bedias = 'bedias',
  Bertram = 'bertram',
  BishopHills = 'bishopHills',
  Blanco = 'blanco',
  BluffDale = 'bluffDale',
  Boling = 'boling',
  Booker = 'booker',
  Borger = 'borger',
  Bovina = 'bovina',
  BoysRanch = 'boysRanch',
  Brazoria = 'brazoria',
  Bridgeport = 'bridgeport',
  Briscoe = 'briscoe',
  Brownfield = 'brownfield',
  Brownwood = 'brownwood',
  BrucevilleEddy = 'brucevilleEddy',
  Bryan = 'bryan',
  BuenaVista = 'buenaVista',
  Bullard = 'bullard',
  Bulverde = 'bulverde',
  Bushland = 'bushland',
  Cactus = 'cactus',
  Caldwell = 'caldwell',
  Canadian = 'canadian',
  Canyon = 'canyon',
  CanyonLakes = 'canyonLakes',
  CauseyNM = 'causeyNM',
  CedarHill = 'cedarHill',
  Channelview = 'channelview',
  Channing = 'channing',
  Chico = 'chico',
  Childress = 'childress',
  Clarendon = 'clarendon',
  Claude = 'claude',
  Clayton = 'clayton',
  Cleveland = 'cleveland',
  Clifton = 'clifton',
  Cloudcroft = 'cloudcroft',
  ClovisNM = 'clovisNM',
  Conroe = 'conroe',
  CopperasCove = 'copperasCove',
  CorpusChristi = 'corpusChristi',
  CottonWoodShores = 'cottonWoodShores',
  Crosby = 'crosby',
  Crosbyton = 'crosbyton',
  Crowell = 'crowell',
  Dalhart = 'dalhart',
  Dallas = 'dallas',
  Damon = 'damon',
  Darrouzett = 'darrouzett',
  Dawn = 'dawn',
  Decatur = 'decatur',
  Denison = 'denison',
  Dimmitt = 'dimmitt',
  Dodson = 'dodson',
  Donna = 'donna',
  Dora = 'dora',
  Dumas = 'dumas',
  EagleNest = 'eagleNest',
  Earth = 'earth',
  Edcough = 'edcough',
  ElCampo = 'elcampo',
  ElPaso = 'elpaso',
  Elemendorf = 'elemendorf',
  Estelline = 'estelline',
  Etter = 'etter',
  Euless = 'euless',
  Evant = 'evant',
  Farnsworth = 'farnsworth',
  Farwell = 'farwell',
  Fischer = 'fischer',
  Floydada = 'floydada',
  Follett = 'follett',
  FortSumner = 'fortSumner',
  Friona = 'friona',
  Fritch = 'fritch',
  Fulton = 'fulton',
  Gilchrist = 'gilchrist',
  Gordonville = 'gordonville',
  Granbury = 'granbury',
  Grandview = 'grandview',
  GraniteShoals = 'graniteShoals',
  Greenville = 'greenville',
  Groom = 'groom',
  Groves = 'groves',
  Gruver = 'gruver',
  Guthrie = 'guthrie',
  Guymon = 'guymon',
  HaleCenter = 'haleCenter',
  Happy = 'happy',
  Harlingen = 'harlingen',
  Hart = 'hart',
  Hartley = 'hartley',
  Hedley = 'hedley',
  Helotes = 'helotes',
  Hereford = 'hereford',
  Higgins = 'higgins',
  Holland = 'holland',
  HoneyGrove = 'honeyGrove',
  HorseshoeBay = 'horseshoeBay',
  Houston = 'houston',
  Howardwick = 'howardwick',
  Hull = 'hull',
  Huntington = 'huntington',
  Huntsville = 'huntsville',
  Ingleside = 'ingleside',
  Iredell = 'iredell',
  Jefferson = 'jefferson',
  Justiceburg = 'justiceburg',
  Katy = 'katy',
  Kempner = 'kempner',
  Kerrick = 'kerrick',
  Kerrville = 'kerrville',
  Killeen = 'killeen',
  Kingsland = 'kingsland',
  Kress = 'kress',
  LaMarque = 'laMarque',
  LaVernia = 'laVernia',
  LaJunta = 'laJunta',
  LakeTanglewood = 'lakeTanglewood',
  Lakeview = 'lakeview',
  Lamesa = 'lamesa',
  Lampasas = 'lampasas',
  Lefors = 'lefors',
  LeliaLake = 'leliaLake',
  Lipscomb = 'lipscomb',
  LittleElm = 'littleElm',
  Littlefield = 'littlefield',
  Livingston = 'livingston',
  Lockney = 'lockney',
  Logan = 'logan',
  LoneOak = 'loneOak',
  Lubbock = 'lubbock',
  Mabank = 'mabank',
  MarbleFalls = 'marbleFalls',
  Marlin = 'marlin',
  Masterson = 'masterson',
  Matador = 'matador',
  Mathis = 'mathis',
  McGregor = 'mcGregor',
  McKinney = 'mcKinney',
  McLean = 'mcLean',
  Memphis = 'memphis',
  Meridian = 'meridian',
  Miami = 'miami',
  Mico = 'mico',
  Midland = 'midland',
  Midlothian = 'midlothian',
  Millsap = 'millsap',
  MirandoCity = 'mirandoCity',
  Mobeetie = 'mobeetie',
  Montgomery = 'montgomery',
  Morse = 'morse',
  Morton = 'morton',
  Muleshoe = 'muleshoe',
  Nazareth = 'nazareth',
  NewBoston = 'newBoston',
  NewBraunfels = 'newBraunfels',
  NewCaney = 'newCaney',
  NewWaverly = 'newWaverly',
  Nocona = 'nocona',
  Odem = 'odem',
  Odessa = 'odessa',
  OldGlory = 'oldGlory',
  Olton = 'olton',
  Orange = 'orange',
  OtherNotInList = 'otherNotInList',
  Paducah = 'paducah',
  Palacios = 'palacios',
  Palisades = 'palisades',
  Pampa = 'pampa',
  Panhandle = 'panhandle',
  Perryton = 'perryton',
  Pharr = 'pharr',
  Plainview = 'plainview',
  Plantersville = 'plantersville',
  PortArthur = 'portArthur',
  Quanah = 'quanah',
  Quitaque = 'quitaque',
  Rockdale = 'rockdale',
  Rockport = 'rockport',
  Ruidoso = 'ruidoso',
  Sachse = 'sachse',
  Salado = 'salado',
  SanAngelo = 'sanAngelo',
  SanAntonio = 'sanAntonio',
  SanJon = 'sanJon',
  Sandia = 'sandia',
  Sanford = 'sanford',
  Sanger = 'sanger',
  SantaRosa = 'santaRosa',
  Sedan = 'sedan',
  Seminole = 'seminole',
  Shallowater = 'shallowater',
  Shamrock = 'shamrock',
  Shepherd = 'shepherd',
  Sherman = 'sherman',
  Silverton = 'silverton',
  Skellytown = 'skellytown',
  Slaton = 'slaton',
  Somerville = 'somerville',
  SourLake = 'sourLake',
  Spearman = 'spearman',
  Spicewood = 'spicewood',
  Spring = 'spring',
  SpringBranch = 'springBranch',
  Springlake = 'springlake',
  Spur = 'spur',
  Stinnett = 'stinnett',
  Stratford = 'stratford',
  Sudan = 'sudan',
  SulphurSprings = 'sulphurSprings',
  Sundown = 'sundown',
  Sunray = 'sunray',
  SunriseBeachVillage = 'sunriseBeachVillage',
  Sunset = 'sunset',
  SweetwaterOk = 'sweetwaterOk',
  Temple = 'temple',
  Texarkana = 'texarkana',
  TexasCity = 'texascity',
  Texhoma = 'texhoma',
  Texline = 'texline',
  Texoma = 'texoma',
  Thicket = 'thicket',
  Timbercreek = 'timbercreek',
  Tow = 'tow',
  Trinidad = 'trinidad',
  Trinity = 'trinity',
  Tulia = 'tulia',
  Turkey = 'turkey',
  Umbarger = 'umbarger',
  ValleDeOro = 'valleDeOro',
  Vega = 'vega',
  Vernon = 'vernon',
  Victoria = 'victoria',
  Vidor = 'vidor',
  Waco = 'waco',
  Washburn = 'washburn',
  Washington = 'washington',
  Wayside = 'wayside',
  Wellington = 'wellington',
  Wheeler = 'wheeler',
  WhiteDeer = 'whiteDeer',
  WichitaFalls = 'wichitaFalls',
  Wildorado = 'wildorado',
  Willis = 'willis',
  WillisPoint = 'willisPoint',
  WillsPoint = 'willsPoint',
  Wimberly = 'wimberly',
  Winnie = 'winnie',
  Winnsboro = 'winnsboro',
  Winona = 'winona'
}

export const AmarilloCitiesLabel: Record<AmarilloCities, string> = {
  [AmarilloCities.Adrian]: 'Adrian',
  [AmarilloCities.Alanreed]: 'Alanreed',
  [AmarilloCities.Allison]: 'Allison',
  [AmarilloCities.Amarillo]: 'Amarillo',
  [AmarilloCities.Amherst]: 'Amherst',
  [AmarilloCities.AngelFire]: 'AngelFire',
  [AmarilloCities.Angleton]: 'Angleton',
  [AmarilloCities.AransasPass]: 'Aransas Pass',
  [AmarilloCities.Arthur]: 'Arthur',
  [AmarilloCities.Athens]: 'Athens',
  [AmarilloCities.Austin]: 'Austin',
  [AmarilloCities.Azle]: 'Azle',
  [AmarilloCities.Balko]: 'Balko',
  [AmarilloCities.Bandera]: 'Bandera',
  [AmarilloCities.Bangs]: 'Bangs',
  [AmarilloCities.Bartlett]: 'Bartlett',
  [AmarilloCities.Bastrop]: 'Bastrop',
  [AmarilloCities.Batson]: 'Batson',
  [AmarilloCities.Beaumont]: 'Beaumont',
  [AmarilloCities.Beaver]: 'Beaver',
  [AmarilloCities.Bedias]: 'Bedias',
  [AmarilloCities.Bertram]: 'Bertram',
  [AmarilloCities.BishopHills]: 'Bishop Hills',
  [AmarilloCities.Blanco]: 'Blanco',
  [AmarilloCities.BluffDale]: 'Bluff Dale',
  [AmarilloCities.Boling]: 'Boling',
  [AmarilloCities.Booker]: 'Booker',
  [AmarilloCities.Borger]: 'Borger',
  [AmarilloCities.Bovina]: 'Bovina',
  [AmarilloCities.BoysRanch]: 'Boys Ranch',
  [AmarilloCities.Brazoria]: 'Brazoria',
  [AmarilloCities.Bridgeport]: 'Bridgeport',
  [AmarilloCities.Briscoe]: 'Briscoe',
  [AmarilloCities.Brownfield]: 'Brownfield',
  [AmarilloCities.Brownwood]: 'Brownwood',
  [AmarilloCities.BrucevilleEddy]: 'Bruceville Eddy',
  [AmarilloCities.Bryan]: 'Bryan',
  [AmarilloCities.BuenaVista]: 'Buena Vista',
  [AmarilloCities.Bullard]: 'Bullard',
  [AmarilloCities.Bulverde]: 'Bulverde',
  [AmarilloCities.Bushland]: 'Bushland',
  [AmarilloCities.Cactus]: 'Cactus',
  [AmarilloCities.Caldwell]: 'Caldwell',
  [AmarilloCities.Canadian]: 'Canadian',
  [AmarilloCities.Canyon]: 'Canyon',
  [AmarilloCities.CanyonLakes]: 'Canyon Lakes',
  [AmarilloCities.CauseyNM]: 'Causey NM',
  [AmarilloCities.CedarHill]: 'Cedar Hill',
  [AmarilloCities.Channelview]: 'Channelview',
  [AmarilloCities.Channing]: 'Channing',
  [AmarilloCities.Chico]: 'Chico',
  [AmarilloCities.Childress]: 'Childress',
  [AmarilloCities.Clarendon]: 'Clarendon',
  [AmarilloCities.Claude]: 'Claude',
  [AmarilloCities.Clayton]: 'Clayton',
  [AmarilloCities.Cleveland]: 'Cleveland',
  [AmarilloCities.Clifton]: 'Clifton',
  [AmarilloCities.Cloudcroft]: 'Cloudcroft',
  [AmarilloCities.ClovisNM]: 'Clovis NM',
  [AmarilloCities.Conroe]: 'Conroe',
  [AmarilloCities.CopperasCove]: 'Copperas Cove',
  [AmarilloCities.CorpusChristi]: 'Corpus Christi',
  [AmarilloCities.CottonWoodShores]: 'Cotton Wood Shores',
  [AmarilloCities.Crosby]: 'Crosby',
  [AmarilloCities.Crosbyton]: 'Crosbyton',
  [AmarilloCities.Crowell]: 'Crowell',
  [AmarilloCities.Dalhart]: 'Dalhart',
  [AmarilloCities.Dallas]: 'Dallas',
  [AmarilloCities.Damon]: 'Damon',
  [AmarilloCities.Darrouzett]: 'Darrouzett',
  [AmarilloCities.Dawn]: 'Dawn',
  [AmarilloCities.Decatur]: 'Decatur',
  [AmarilloCities.Denison]: 'Denison',
  [AmarilloCities.Dimmitt]: 'Dimmitt',
  [AmarilloCities.Dodson]: 'Dodson',
  [AmarilloCities.Donna]: 'Donna',
  [AmarilloCities.Dora]: 'Dora',
  [AmarilloCities.Dumas]: 'Dumas',
  [AmarilloCities.EagleNest]: 'Eagle Nest',
  [AmarilloCities.Earth]: 'Earth',
  [AmarilloCities.Edcough]: 'Edcough',
  [AmarilloCities.ElCampo]: 'ElCampo',
  [AmarilloCities.ElPaso]: 'ElPaso',
  [AmarilloCities.Elemendorf]: 'Elemendorf',
  [AmarilloCities.Estelline]: 'Estelline',
  [AmarilloCities.Etter]: 'Etter',
  [AmarilloCities.Euless]: 'Euless',
  [AmarilloCities.Evant]: 'Evant',
  [AmarilloCities.Farnsworth]: 'Farnsworth',
  [AmarilloCities.Farwell]: 'Farwell',
  [AmarilloCities.Fischer]: 'Fischer',
  [AmarilloCities.Floydada]: 'Floydada',
  [AmarilloCities.Follett]: 'Follett',
  [AmarilloCities.FortSumner]: 'Fort Sumner',
  [AmarilloCities.Friona]: 'Friona',
  [AmarilloCities.Fritch]: 'Fritch',
  [AmarilloCities.Fulton]: 'Fulton',
  [AmarilloCities.Gilchrist]: 'Gilchrist',
  [AmarilloCities.Gordonville]: 'Gordonville',
  [AmarilloCities.Granbury]: 'Granbury',
  [AmarilloCities.Grandview]: 'Grandview',
  [AmarilloCities.GraniteShoals]: 'Granite Shoals',
  [AmarilloCities.Greenville]: 'Greenville',
  [AmarilloCities.Groom]: 'Groom',
  [AmarilloCities.Groves]: 'Groves',
  [AmarilloCities.Gruver]: 'Gruver',
  [AmarilloCities.Guthrie]: 'Guthrie',
  [AmarilloCities.Guymon]: 'Guymon',
  [AmarilloCities.HaleCenter]: 'Hale Center',
  [AmarilloCities.Happy]: 'Happy',
  [AmarilloCities.Harlingen]: 'Harlingen',
  [AmarilloCities.Hart]: 'Hart',
  [AmarilloCities.Hartley]: 'Hartley',
  [AmarilloCities.Hedley]: 'Hedley',
  [AmarilloCities.Helotes]: 'Helotes',
  [AmarilloCities.Hereford]: 'Hereford',
  [AmarilloCities.Higgins]: 'Higgins',
  [AmarilloCities.Holland]: 'Holland',
  [AmarilloCities.HoneyGrove]: 'Honey Grove',
  [AmarilloCities.HorseshoeBay]: 'Horseshoe Bay',
  [AmarilloCities.Houston]: 'Houston',
  [AmarilloCities.Howardwick]: 'Howardwick',
  [AmarilloCities.Hull]: 'Hull',
  [AmarilloCities.Huntington]: 'Huntington',
  [AmarilloCities.Huntsville]: 'Huntsville',
  [AmarilloCities.Ingleside]: 'Ingleside',
  [AmarilloCities.Iredell]: 'Iredell',
  [AmarilloCities.Jefferson]: 'Jefferson',
  [AmarilloCities.Justiceburg]: 'Justiceburg',
  [AmarilloCities.Katy]: 'Katy',
  [AmarilloCities.Kempner]: 'Kempner',
  [AmarilloCities.Kerrick]: 'Kerrick',
  [AmarilloCities.Kerrville]: 'Kerrville',
  [AmarilloCities.Killeen]: 'Killeen',
  [AmarilloCities.Kingsland]: 'Kingsland',
  [AmarilloCities.Kress]: 'Kress',
  [AmarilloCities.LaMarque]: 'La Marque',
  [AmarilloCities.LaVernia]: 'La Vernia',
  [AmarilloCities.LaJunta]: 'La Junta',
  [AmarilloCities.LakeTanglewood]: 'Lake Tanglewood',
  [AmarilloCities.Lakeview]: 'Lakeview',
  [AmarilloCities.Lamesa]: 'Lamesa',
  [AmarilloCities.Lampasas]: 'Lampasas',
  [AmarilloCities.Lefors]: 'Lefors',
  [AmarilloCities.LeliaLake]: 'Lelia Lake',
  [AmarilloCities.Lipscomb]: 'Lipscomb',
  [AmarilloCities.LittleElm]: 'Little Elm',
  [AmarilloCities.Littlefield]: 'Littlefield',
  [AmarilloCities.Livingston]: 'Livingston',
  [AmarilloCities.Lockney]: 'Lockney',
  [AmarilloCities.Logan]: 'Logan',
  [AmarilloCities.LoneOak]: 'Lone Oak',
  [AmarilloCities.Lubbock]: 'Lubbock',
  [AmarilloCities.Mabank]: 'Mabank',
  [AmarilloCities.MarbleFalls]: 'Marble Falls',
  [AmarilloCities.Marlin]: 'Marlin',
  [AmarilloCities.Masterson]: 'Masterson',
  [AmarilloCities.Matador]: 'Matador',
  [AmarilloCities.Mathis]: 'Mathis',
  [AmarilloCities.McGregor]: 'McGregor',
  [AmarilloCities.McKinney]: 'McKinney',
  [AmarilloCities.McLean]: 'McLean',
  [AmarilloCities.Memphis]: 'Memphis',
  [AmarilloCities.Meridian]: 'Meridian',
  [AmarilloCities.Miami]: 'Miami',
  [AmarilloCities.Mico]: 'Mico',
  [AmarilloCities.Midland]: 'Midland',
  [AmarilloCities.Midlothian]: 'Midlothian',
  [AmarilloCities.Millsap]: 'Millsap',
  [AmarilloCities.MirandoCity]: 'Mirando City',
  [AmarilloCities.Mobeetie]: 'Mobeetie',
  [AmarilloCities.Montgomery]: 'Montgomery',
  [AmarilloCities.Morse]: 'Morse',
  [AmarilloCities.Morton]: 'Morton',
  [AmarilloCities.Muleshoe]: 'Muleshoe',
  [AmarilloCities.Nazareth]: 'Nazareth',
  [AmarilloCities.NewBoston]: 'New Boston',
  [AmarilloCities.NewBraunfels]: 'New Braunfels',
  [AmarilloCities.NewCaney]: 'New Caney',
  [AmarilloCities.NewWaverly]: 'New Waverly',
  [AmarilloCities.Nocona]: 'Nocona',
  [AmarilloCities.Odem]: 'Odem',
  [AmarilloCities.Odessa]: 'Odessa',
  [AmarilloCities.OldGlory]: 'Old Glory',
  [AmarilloCities.Olton]: 'Olton',
  [AmarilloCities.Orange]: 'Orange',
  [AmarilloCities.OtherNotInList]: 'Other Not In List',
  [AmarilloCities.Paducah]: 'Paducah',
  [AmarilloCities.Palacios]: 'Palacios',
  [AmarilloCities.Palisades]: 'Palisades',
  [AmarilloCities.Pampa]: 'Pampa',
  [AmarilloCities.Panhandle]: 'Panhandle',
  [AmarilloCities.Perryton]: 'Perryton',
  [AmarilloCities.Pharr]: 'Pharr',
  [AmarilloCities.Plainview]: 'Plainview',
  [AmarilloCities.Plantersville]: 'Plantersville',
  [AmarilloCities.PortArthur]: 'Port Arthur',
  [AmarilloCities.Quanah]: 'Quanah',
  [AmarilloCities.Quitaque]: 'Quitaque',
  [AmarilloCities.Rockdale]: 'Rockdale',
  [AmarilloCities.Rockport]: 'Rockport',
  [AmarilloCities.Ruidoso]: 'Ruidoso',
  [AmarilloCities.Sachse]: 'Sachse',
  [AmarilloCities.Salado]: 'Salado',
  [AmarilloCities.SanAngelo]: 'San Angelo',
  [AmarilloCities.SanAntonio]: 'San Antonio',
  [AmarilloCities.SanJon]: 'San Jon',
  [AmarilloCities.Sandia]: 'Sandia',
  [AmarilloCities.Sanford]: 'Sanford',
  [AmarilloCities.Sanger]: 'Sanger',
  [AmarilloCities.SantaRosa]: 'Santa Rosa',
  [AmarilloCities.Sedan]: 'Sedan',
  [AmarilloCities.Seminole]: 'Seminole',
  [AmarilloCities.Shallowater]: 'Shallowater',
  [AmarilloCities.Shamrock]: 'Shamrock',
  [AmarilloCities.Shepherd]: 'Shepherd',
  [AmarilloCities.Sherman]: 'Sherman',
  [AmarilloCities.Silverton]: 'Silverton',
  [AmarilloCities.Skellytown]: 'Skellytown',
  [AmarilloCities.Slaton]: 'Slaton',
  [AmarilloCities.Somerville]: 'Somerville',
  [AmarilloCities.SourLake]: 'Sour Lake',
  [AmarilloCities.Spearman]: 'Spearman',
  [AmarilloCities.Spicewood]: 'Spicewood',
  [AmarilloCities.Spring]: 'Spring',
  [AmarilloCities.SpringBranch]: 'Spring Branch',
  [AmarilloCities.Springlake]: 'Spring Lake',
  [AmarilloCities.Spur]: 'Spur',
  [AmarilloCities.Stinnett]: 'Stinnett',
  [AmarilloCities.Stratford]: 'Stratford',
  [AmarilloCities.Sudan]: 'Sudan',
  [AmarilloCities.SulphurSprings]: 'Sulphur Springs',
  [AmarilloCities.Sundown]: 'Sundown',
  [AmarilloCities.Sunray]: 'Sunray',
  [AmarilloCities.SunriseBeachVillage]: 'Sunrise Beach Village',
  [AmarilloCities.Sunset]: 'Sunset',
  [AmarilloCities.SweetwaterOk]: 'Sweetwater Ok',
  [AmarilloCities.Temple]: 'Temple',
  [AmarilloCities.Texarkana]: 'Texarkana',
  [AmarilloCities.TexasCity]: 'Texas City',
  [AmarilloCities.Texhoma]: 'Texhoma',
  [AmarilloCities.Texline]: 'Texline',
  [AmarilloCities.Texoma]: 'Texoma',
  [AmarilloCities.Thicket]: 'Thicket',
  [AmarilloCities.Timbercreek]: 'Timbercreek',
  [AmarilloCities.Tow]: 'Tow',
  [AmarilloCities.Trinidad]: 'Trinidad',
  [AmarilloCities.Trinity]: 'Trinity',
  [AmarilloCities.Tulia]: 'Tulia',
  [AmarilloCities.Turkey]: 'Turkey',
  [AmarilloCities.Umbarger]: 'Umbarger',
  [AmarilloCities.ValleDeOro]: 'Valle De Oro',
  [AmarilloCities.Vega]: 'Vega',
  [AmarilloCities.Vernon]: 'Vernon',
  [AmarilloCities.Victoria]: 'Victoria',
  [AmarilloCities.Vidor]: 'Vidor',
  [AmarilloCities.Waco]: 'Waco',
  [AmarilloCities.Washburn]: 'Washburn',
  [AmarilloCities.Washington]: 'Washington',
  [AmarilloCities.Wayside]: 'Wayside',
  [AmarilloCities.Wellington]: 'Wellington',
  [AmarilloCities.Wheeler]: 'Wheeler',
  [AmarilloCities.WhiteDeer]: 'WhiteDeer',
  [AmarilloCities.WichitaFalls]: 'Wichita Falls',
  [AmarilloCities.Wildorado]: 'Wildorado',
  [AmarilloCities.Willis]: 'Willis',
  [AmarilloCities.WillisPoint]: 'Willis Point',
  [AmarilloCities.WillsPoint]: 'Wills Point',
  [AmarilloCities.Wimberly]: 'Wimberly',
  [AmarilloCities.Winnie]: 'Winnie',
  [AmarilloCities.Winnsboro]: 'Winnsboro',
  [AmarilloCities.Winona]: 'Winona'
};
